export default "__VITE_ASSET__BELfu1qH__"